import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  Alert,
} from '@mui/material';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

const CompleteProfileForm = () => {
  const [formData, setFormData] = useState({ firstName: '', lastName: '' });
  const [userId, setUserId] = useState(null);
  const [token, setToken] = useState(null);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('userId');
    const t = params.get('token');
    if (id && t) {
      setUserId(id);
      setToken(t);
    } else {
      setError("Lien invalide ou incomplet.");
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId || !token) {
      return;
    }

    const payload = { userId, token, ...formData };

    try {
      const response = await fetch(`${API_BASE_URL}/registration/completeProfile`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload) ,
      });

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      setSuccess('Votre profil a été complété avec succès !');
    } catch (err) {
      console.error("❌ Error submitting profile:", err);
      setError("Impossible de compléter le profil.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Finalisez votre profil
        </Typography>
        <Typography variant="body1" gutterBottom>
          Entrez votre prénom et nom pour finaliser votre inscription.
        </Typography>

        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}

        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3 }}>
          <TextField
            required fullWidth name="firstName" label="Prénom"
            value={formData.firstName} onChange={handleChange} sx={{ mb: 2 }}
          />
          <TextField
            required fullWidth name="lastName" label="Nom"
            value={formData.lastName} onChange={handleChange} sx={{ mb: 3 }}
          />
          <Button type="submit" variant="contained" fullWidth>
            Finaliser
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default CompleteProfileForm;
